import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton } from '../paging-button/index-chunk.esm.js';
import { E as EGDSSecondaryButton } from '../secondary-button/index-chunk.esm.js';

class EGDSFloatingButton extends React.Component {
    static displayName = 'EGDSFloatingButton';
    render() {
        const { props } = this;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-floating`, props.className);
        return jsx(EGDSSecondaryButton, { ...props, className: cssClassNames });
    }
}

class EGDSFloatingActionButton extends React.Component {
    static displayName = 'EGDSFloatingActionButton';
    render() {
        const { fixed, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-floating-action`, props.className, {
            'uitk-button-floating-action-fixed': fixed,
        });
        return jsx(EGDSButton, { ...props, className: cssClassNames });
    }
}

export { EGDSFloatingButton as E, EGDSFloatingActionButton as a };
//# sourceMappingURL=index-chunk.esm.js.map
